import React, { useCallback, useMemo } from "react";
import { useForm } from "storybook/utils/form";
import { z } from "zod";
import { useTransifexLoader } from "context/transifex-loader";
import { SelectedComponentProps } from "storybook/components/select";
import { GlobeIcon } from "components/icons/globe";
import { Typography } from "storybook/components/typography";
import styled from "styled-components";
import { Language } from "context/preferred-language";

const SelectedComponentContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  text-transform: none;
`;

const selectedComponent = ({
  selectedItems,
  placeholder,
}: SelectedComponentProps) => {
  const selectText = selectedItems.length ? selectedItems[0].text : placeholder;
  return (
    <SelectedComponentContainer>
      <GlobeIcon />
      <Typography
        theme="default"
        variant="subtitle1"
        color="black"
        component="p"
      >
        <b>{selectText}</b>
      </Typography>
    </SelectedComponentContainer>
  );
};

export const LanguagePicker = () => {
  const { lang, isLoaded: isTransifexLoaded } = useTransifexLoader();

  const values = useMemo(
    () => ({
      language: lang,
    }),
    [lang]
  );

  const { Form, Select } = useForm({
    schema: z.object({
      language: z.string(),
    }),
    values,
  });

  const handleChange = useCallback(
    (lang: any) => {
      if (isTransifexLoaded) {
        window.Transifex.live.translateTo(lang);
      }
    },
    [isTransifexLoaded]
  );

  return (
    <Form onSubmit={() => null}>
      <Select
        theme="future"
        label="Select Language"
        hideLabel={true}
        hideDirty={true}
        name="language"
        onChange={handleChange}
        selectedComponent={selectedComponent}
        className="notranslate"
      >
        <Select.Option value={Language.ENGLISH}>English</Select.Option>
        <Select.Option value={Language.SPANISH}>Español</Select.Option>
        <Select.Option value={Language.PORTUGUESE}>Português</Select.Option>
      </Select>
    </Form>
  );
};
